:global(.rpv-full-screen__overlay) {
  display: none;
}

.btnRightPdf {
  margin-left: auto;
}

.height100 {
  height: 100%;
}

.containerError {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}

.errorPdf {
  background-color: #f36565;
  border-radius: 0.25rem;
  color: #fff;
  padding: 0.5rem;
}

.worker {
  height: 560px;
}

.progressBar {
  width: 300px;
}
